/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * limit: 每页显示条数
 *
 */
 // const BASE_URL = 'http://localhost:8082';
// const BASE_URL = "http://lady-api.im502.com";
const BASE_URL = "http://www.5288u.com:8081";
// const BASE_URL = "http://localhost:8081";
// const BASE_URL = "https://lady-api.yakult-gz.com.cn";

// const WEB_URL = "http://ent.im502.com";
// const WEB_URL = "https://ent.yakult-gz.com.cn";
const WEB_URL = "http://www.5288u.com:8081";
// const WEB_URL = "http://localhost:8081";

// const ROUTER_MODE = 'history';
const ROUTER_MODE = 'hash';

const LIMIT = 10;

//微信授权企业ID
// const WX_CODE = 'ww0cac3f861811b6fd';
const WX_CODE = 'ww93ab08cec773d43f';

export { BASE_URL, WEB_URL, ROUTER_MODE, LIMIT, WX_CODE };

